import { createContext, useContext, useReducer } from 'react'
import { reducer } from './reducer'
import { useComponentIsMountedRef } from 'Hooks'

TableDataContext = createContext()

initialState = {}

export TableDataProvider = ({ children }) ->
  isMounted = useComponentIsMountedRef()
  [state, dispatch] = useReducer(reducer, initialState)

  protectedDispatch = (args...) ->
    return unless isMounted.current
    dispatch(args...)

  <TableDataContext.Provider value={[state, protectedDispatch]}>
    { children }
  </TableDataContext.Provider>

export useTableData = () ->
  useContext(TableDataContext)
